module.exports = __webpack_public_path__ + "img/40_38_068_710.b91627a0.jpg";